var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3068 3.6955C19.5358 2.9245 18.5118 2.50049 17.4218 2.50049C16.3328 2.50049 15.3078 2.9245 14.5368 3.6955L4.00384 14.2285C3.63284 14.5995 3.3908 15.0685 3.3048 15.5855L2.51482 20.3235C2.46082 20.6445 2.56681 20.9735 2.79681 21.2035C2.98681 21.3945 3.2458 21.4995 3.5108 21.4995C3.5658 21.4995 3.62081 21.4955 3.67681 21.4855L8.41583 20.6955C8.93283 20.6095 9.40084 20.3685 9.77184 19.9975L20.3048 9.46448C21.0758 8.69348 21.4998 7.6695 21.4998 6.5795C21.4998 5.4895 21.0768 4.4655 20.3068 3.6955ZM9.06585 19.2915C8.84285 19.5145 8.5618 19.6585 8.2528 19.7105L3.5028 20.4885L4.29284 15.7505C4.34484 15.4395 4.48885 15.1585 4.71185 14.9365L12.9718 6.67648L17.3268 11.0325L9.06585 19.2915ZM19.5998 8.75848L18.0328 10.3255L13.6778 5.96948L15.2448 4.4025C15.8268 3.8205 16.5998 3.50049 17.4228 3.50049C18.2458 3.50049 19.0198 3.8205 19.6008 4.4025C20.1828 4.9845 20.5028 5.75747 20.5028 6.58047C20.5028 7.40347 20.1818 8.17648 19.5998 8.75848Z",
    fill: "#FD4EF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenPink);
export default __webpack_public_path__ + "static/media/pen-pink.fa39b320cc82c57d7f11d658f45a74b6.svg";
export { ForwardRef as ReactComponent };